// SEO Configuration and Schema Markup
export const siteConfig = {
  siteName: 'Agility',
  siteUrl: 'https://www.agilitytech.ai',
  defaultTitle: 'Agility | Rapid AI Implementation & Data Engineering',
  defaultDescription: 'Rapid AI implementation and deployment in weeks, not months. Expert teams delivering automation, data engineering, and predictive analytics. 200+ successful implementations with 60-80% faster timelines than traditional firms.',
  twitterHandle: '@agilityai',
  socialMedia: {
    linkedin: 'https://www.linkedin.com/company/agilitytech/',
    twitter: 'https://twitter.com/agilityai',
  },
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Agility",
  "legalName": "Agility",
  "url": "https://www.agilitytech.ai",
  "logo": "https://www.agilitytech.ai/agility hex fonts.png",
  "description": "Leading AI consulting firm specializing in artificial intelligence, machine learning, and data analytics solutions for enterprises worldwide.",
  "foundingDate": "2025",
  "founders": [{
    "@type": "Person",
    "name": "Nihar Thakkar",
    "jobTitle": "Founder & CEO",
    "sameAs": "https://www.linkedin.com/in/niharthakkar/"
  }],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "14th floor, Sun Gravitas, Shyamal Cross Road, Rajmani Society",
    "addressLocality": "Ahmedabad",
    "addressRegion": "Gujarat",
    "postalCode": "380015",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "sales",
    "telephone": "+91-7041402034",
    "email": "hello@agilitytech.ai",
    "areaServed": ["IN", "US", "GB", "IL", "Caribbean"],
    "availableLanguage": ["English"]
  },
  "sameAs": [
    "https://www.linkedin.com/company/agilitytech/",
    "https://clutch.co/profile/agility-3"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "10",
    "bestRating": "5",
    "worstRating": "1"
  }
};

export const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "Agility",
  "image": "https://www.agilitytech.ai/agility hex fonts.png",
  "url": "https://www.agilitytech.ai",
  "telephone": "+91-7041402034",
  "priceRange": "$$$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "14th floor, Sun Gravitas, Shyamal Cross Road, Rajmani Society",
    "addressLocality": "Ahmedabad",
    "addressRegion": "Gujarat",
    "postalCode": "380015",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 23.0225,
    "longitude": 72.5714
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  }
};

export const servicesOffered = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "AI Consulting",
    "provider": {
      "@type": "Organization",
      "name": "Agility"
    },
    "description": "Strategic AI consulting and implementation services to transform business operations with artificial intelligence.",
    "areaServed": "Worldwide",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "AI Consulting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI Strategy Development",
            "description": "Comprehensive AI roadmap and strategy development"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Machine Learning Implementation",
            "description": "Custom ML models and predictive analytics solutions"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI Process Automation",
            "description": "Intelligent automation for business processes"
          }
        }
      ]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Data Engineering",
    "provider": {
      "@type": "Organization",
      "name": "Agility"
    },
    "description": "End-to-end data engineering solutions including ETL pipelines, data warehousing, and cloud infrastructure optimization.",
    "areaServed": "Worldwide"
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Business Intelligence",
    "provider": {
      "@type": "Organization",
      "name": "Agility"
    },
    "description": "Real-time BI dashboards and analytics solutions using Power BI, Tableau, and custom web applications.",
    "areaServed": "Worldwide"
  }
];

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What AI consulting services does Agility provide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Agility provides comprehensive AI consulting services including AI strategy development, machine learning implementation, automation solutions, data engineering, predictive analytics, and business intelligence. We serve 30+ countries with 250+ technology partnerships."
      }
    },
    {
      "@type": "Question",
      "name": "Which industries does Agility serve?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We serve multiple industries including healthcare, manufacturing, finance, insurance, retail, and food services. Our solutions have helped reduce operational costs by 30% on average and improve decision-making speed by 80%."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to implement an AI solution?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our rapid implementation approach delivers AI solutions in 3-8 weeks depending on complexity. Automation projects: 3-6 weeks. Data engineering: 4-8 weeks. AI/ML solutions: 4-12 weeks. We're 60-80% faster than traditional consulting firms through agile methodologies and lean teams."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide implementation support after deployment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide 24/7 post-implementation support including continuous monitoring, optimization, and maintenance. Our support packages ensure your AI solutions continue delivering value with proactive updates and issue resolution."
      }
    },
    {
      "@type": "Question",
      "name": "What makes Agility's implementation approach different?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We deploy senior engineering teams directly on your project no layers of account managers or junior staff. Our agile squads ship production-ready code in weeks, not months, with continuous delivery and real-time collaboration."
      }
    },
    {
      "@type": "Question",
      "name": "What is the average ROI of Agility solutions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our clients typically see 30% cloud savings through infrastructure optimization, 80% faster reporting with real-time BI dashboards, and 99.9% data accuracy through secure ETL pipelines. ROI varies by industry and use case."
      }
    },
    {
      "@type": "Question",
      "name": "Does Agility provide 24/7 support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide 24/7 global support for all our enterprise clients. Our support includes continuous performance monitoring, optimization, and proactive issue resolution."
      }
    }
  ]
};

export const reviewSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "Organization",
      "name": "Agility"
    },
    "author": {
      "@type": "Person",
      "name": "Manjit Jhooty",
      "jobTitle": "CEO",
      "worksFor": {
        "@type": "Organization",
        "name": "Jhoots Group"
      }
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "reviewBody": "I had the pleasure of working with Agility on Data Warehousing and Automation projects. They consistently deliver exceptional results and demonstrate deep technical expertise. Their innovative solutions and dedication to quality have greatly benefited our projects. I highly recommend Agility for any data-driven initiatives."
  },
  {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "Organization",
      "name": "Agility"
    },
    "author": {
      "@type": "Person",
      "name": "Lindsay Williams",
      "jobTitle": "CEO",
      "worksFor": {
        "@type": "Organization",
        "name": "FoodDrop"
      }
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "reviewBody": "Working with Agility was a game-changer. They didn't just meet deadlines they anticipated problems before they arose and solved them efficiently. Their ability to operate autonomously while maintaining exceptional quality made them an invaluable partner for our projects."
  }
];

// Page-specific metadata
export const pageMetadata = {
  home: {
    title: 'Agility | AI Consulting Company | Rapid AI Implementation in Weeks',
    description: 'AI consulting company delivering production-ready AI in 3-8 weeks. Expert AI implementation, automation, data engineering, and generative AI consulting. 200+ successful deployments across healthcare, manufacturing, and finance. 60-80% faster than traditional firms.',
    keywords: 'AI consulting company, AI consulting services, AI implementation company, generative AI consulting, AI automation consulting, data and AI consulting, rapid AI implementation, AI consulting India, AI consulting Ahmedabad',
  },
  about: {
    title: 'About Us | Agility - Young, Agile AI Team',
    description: 'Meet our young, agile team (avg age 24) delivering cutting-edge AI and data solutions. Learn about our mission to accelerate your data-powered future with proven methodologies.',
    keywords: 'AI consulting team, data science team, AI experts, machine learning engineers, data engineering team, agile development, AI company',
  },
  solutions: {
    automation: {
      title: 'Rapid Automation Implementation | 3-Week Deployment | Agility',
      description: 'Fast automation implementation in 3-6 weeks. Streamline operations with intelligent process automation. 95% reduction in manual effort. Custom AI-powered automation deployed rapidly for enterprises.',
      keywords: 'rapid automation implementation, fast automation deployment, quick automation solutions, automation implementors, RPA implementation, workflow automation deployment, business process automation implementation',
    },
    ai: {
      title: 'AI Implementation Services | Fast ML Deployment | Agility',
      description: 'Rapid AI and machine learning implementation in weeks. Enterprise AI deployment for predictive analytics, NLP, and intelligent systems. 200+ successful AI implementations with accelerated timelines.',
      keywords: 'AI implementation, rapid AI deployment, ML implementation services, fast AI integration, AI implementors, machine learning deployment, predictive analytics implementation, enterprise AI implementation',
    },
    dataEngineering: {
      title: 'Data Engineering Implementation | Fast ETL Deployment | Agility',
      description: 'Rapid data engineering implementation including ETL pipelines, data warehousing, and cloud migration. 99.9% data accuracy. Fast deployment in 4-8 weeks with proven methodologies.',
      keywords: 'data engineering implementation, rapid ETL deployment, fast data pipeline implementation, data warehouse deployment, cloud migration implementation, data integration services, data engineering implementors',
    },
  },
  insights: {
    title: 'AI & Data Insights Blog | Agility',
    description: 'Expert insights on AI, machine learning, data engineering, and digital transformation. Learn from our 200+ successful implementations.',
    keywords: 'AI blog, machine learning insights, data engineering articles, AI trends, data science blog, AI case studies',
  },
  careers: {
    title: 'Careers at Agility | Join Our Young, Agile AI Team',
    description: 'Join our fast-moving, young team (avg age 24) working on cutting-edge AI and data projects. We ship quickly and make an impact.',
    keywords: 'AI careers, data science jobs, machine learning jobs, data engineering careers, AI company jobs, tech careers',
  },
  contact: {
    title: 'Contact Us | Book Free Data Maturity Audit | Agility',
    description: 'Get in touch for a free data maturity audit. 24/7 global support, 5-star rated service, serving 30+ countries with 250+ tech partnerships.',
    keywords: 'contact AI consulting, AI consultation, data maturity audit, AI strategy session, enterprise AI contact',
  },
  youtube: {
    title: 'AI Videos & Tutorials | Agility YouTube Channel',
    description: 'Watch Agility\'s full video library AI consulting insights, machine learning tutorials, automation deep-dives, and thought leadership. New videos every week on rapid AI implementation.',
    keywords: 'AI videos, machine learning tutorials, AI consulting videos, automation tutorials, data engineering videos, AI YouTube channel, AI thought leadership, generative AI videos, AI implementation tutorials',
  },
};
